import './style.css'

const Scrollbar = () => {
    const scrollToTop = (e) => {
        e.preventDefault();
        
        const scrollStep = -window.scrollY / (500 / 15);
        const scrollInterval = setInterval(() => {
            if (window.scrollY !== 0) {
                window.scrollBy(0, scrollStep);
            } else {
                clearInterval(scrollInterval);
            }
        }, 15);
    }

    return(
        <div className="col-lg-12">
            <div className="header-menu">
                <ul className="smothscroll">
                    <li>
                        <a href="#top" onClick={scrollToTop}>
                            <i className="ti-arrow-up"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        
    )
}

export default Scrollbar;
